import clsx from "clsx";

import { type Sorting } from "../../edit-breakdown/advanced-editor/types";

interface Props {
  name: string;
  sorting: Sorting;
  onClick: (sorting: Sorting) => void;
}

export const SortDirection = ({ name, sorting, onClick }: Props) => {
  return (
    <div
      onClick={() =>
        onClick({ ...sorting, order: sorting.order === "asc" ? "desc" : "asc" })
      }
    >
      {name === sorting.column && sorting.order === "desc" && (
        <div
          className={clsx(
            "flex justify-center items-center bg-cosmic-3 rounded w-6 h-6",
            "cursor-pointer text-cosmic",
          )}
        >
          <i className="fa-regular fa-arrow-down" />
        </div>
      )}
      {name === sorting.column && sorting.order === "asc" && (
        <div
          className={clsx(
            "flex justify-center items-center bg-cosmic-3 rounded w-6 h-6",
            "cursor-pointer text-cosmic",
          )}
        >
          <i className="fa-regular fa-arrow-up" />
        </div>
      )}
    </div>
  );
};
